// extracted by mini-css-extract-plugin
export default {"card":"Comment_card__74d-7"};